import Ingredient from './Ingredient';

const Ingredients = ({ingredients, portions}) => {
    return (
        <div>
            <ul>
             {ingredients.map((ingredient) => (
          <li key={ingredient.id}  className = 'ingredientItem'>
          <Ingredient ingredient = {ingredient} portions={portions}></Ingredient>
          </li>
          ))}
          </ul>
        </div>
    )
}

export default Ingredients
